import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {SettingsAmenity} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {Attachment} from '../types/email-data.types';
import {HistoryItem} from '../views/directory-item/activity/history-item.class';
import {EmailService} from './email.service';
import {AccountPermissionsService} from './account-permissions.service';
import {filter, tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

declare const $: any;

@Injectable()
export class SettingsDirectoryService {
    isSettingsAmenitiesModalShow = false;
    isScheduleModalShow = false;
    isDisabledDatesModalShow = false;
    isLegalAgreementModalShow = false;
    isBookingRequestModalShow = false;
    isDisclaimerModalShow = false;
    showDetailedView = false;
    isPaymentModalShow = false;
    isViewAttachmentModalShow = false;
    isRemindersModalShow = false;
    firstTimeLoading = true;
    isNotificationModalShow = false;
    selectedItemData: any;
    selectedReminderIndex = null;
    chosenCorporation: any;
    serviceRequestInServiceRequestModal: SettingsAmenity;

    data = {
        total: null,
        corporations: {
            get: null,
            data: [],
            total: null
        }
    };

    tabId = 'allSettingsDirectory';
    spinnerShow = true;
    showServiceUnavailable = false;
    selectedItemFormattedBuildingsArray: Array<any> = [];
    activities: HistoryItem[];
    modalSpinnerShow = false;
    attachmentsToDisplay: Array<any> = [];
    serviceName: string = 'bldn';
    userRoles: Array<any> = [];
    updatedByStaffMultiselectArray: Array<any> = [];
    updatedByResidentMultiselectArray: Array<any> = [];
    updatedByStaffCheckbox = false;
    updatedByResidentCheckbox = false;
    updatedApprovedCheckbox = false;
    updatedDeclinedCheckbox = false;
    showCorporationsList = true;
    notificationModalStaffOrResident = '';
    notificationModalNotificationType = '';

    constructor(public es: EmailService,
                public api: ApiClientService,
                public urlService: UrlService,
                public emptyRowService: EmptyRowService,
                public account: AccountPermissionsService) {
    }

    resetData() {
        this.data.corporations.data = [];
        this.data.corporations.total = null;
        this.showDetailedView = false;
        this.selectedItemData = null;
        this.chosenCorporation = null;
    }

    toggleDetailedView(data, state: boolean): void {
        if (!data)
            this.selectedItemData.checked = false;
        this.selectedItemData = data ? data : null;
        this.showDetailedView = state;
        if (this.selectedItemData) {
            for (const field in this.selectedItemData.formFields)
                this.selectedItemData.formFields[field].editMode = false;

            this.getResidentsNotificationSettings();
        }
        this.emptyNotificationArrays();
        this.formatNotificationSettingsRoles();
    }

    showAttachment(attachment) {
        const attachmentAsObject = new Attachment(attachment.name, 0, attachment.path);
        if (attachmentAsObject.isImage()) {
            this.es.attachmentInViewAttachmentModal = attachmentAsObject;
            this.es.isViewAttachmentModalShow = true;
        } else if (attachmentAsObject.isNeedViewer()) {
            attachmentAsObject.openViewer();
        } else {
            attachmentAsObject.downloadAttachment();
        }
    }

    public getUserRoles() {
        const url = `/api/v1/role.json`;
        this.api.getInfiniteList('oauthUrl', url, 1000).subscribe(
            res => {
                this.userRoles = res.entities.map(role => ({id: role.id.toString(), itemName: role.name}));
            },
            error => this.api.errorHandler(error, 'Failed get Roles')
        );
    }

    public formatNotificationSettingsRoles(): any {
        if (this.selectedItemData) {
            this.selectedItemData.staffNotificationSettings.forEach((notificationSetting) => {
                const itemName = notificationSetting.action == 'updated_by_staff' ? 'updatedByStaff' : 'updatedByResident';
                this[itemName + 'Checkbox'] = notificationSetting.enableStatus;
                notificationSetting.userRoles.forEach((role) => {
                    this[itemName + 'MultiselectArray'].push({
                        id: role.bdId,
                        itemName: role.roleName
                    });
                });
            });
        }
    }

    emptyNotificationArrays(): void {
        this.updatedByStaffMultiselectArray = [];
        this.updatedByResidentMultiselectArray = [];
        this.updatedByStaffCheckbox = false;
        this.updatedByResidentCheckbox = false;
    }

    getCorporations(scrollToTop?): void {
        this.getCorporationsByQueryParams(scrollToTop).subscribe();
    }

    getCorporationsByQueryParams(scrollToTop?) {
        this.showServiceUnavailable = false;
        const queryParams = this.urlService.getQueryParamsString();
        const query = queryParams ? queryParams.slice(0, queryParams.indexOf('&order-by')) : '';
        const url = `/v1/corporation_number.json?${query}&order-by=name|asc&expand=reminders,settings,buildings,staffNotificationSettings,staffNotificationSettings.userRoles`;
        return this.api.getJson('domainBD', url).pipe(
            createInitialNetworkEntity(),
            resolveNetworkEntity(),
            tap(({loading}) => this.spinnerShow = loading),
            tap(
                (res) => {
                    this.data.corporations.data = res.entities;
                    this.data.corporations.total = res.total;
                    this.emptyRowService.fillEmptyRow();
                    if ($('.table')[0] && scrollToTop)
                        $('.table')[0].scrollIntoView();
                },
                (error) => {
                    this.showServiceUnavailable = true;
                    this.spinnerShow = false;
                    this.api.errorHandler(error, 'Failed get corporations');
                },
                () => {
                    this.spinnerShow = false;
                    this.showCorporationsList = true;
                }
            ),
            filter(({finished}) => finished),
            tap(() => {
                if (this.selectedItemData) {
                    const match = this.data.corporations.data.find(si => si.id == this.selectedItemData.id);
                    if (match) {
                        match.checked = true;
                        this.toggleDetailedView(match, true);
                    } else
                        this.showDetailedView = false;
                }
            })
        );
    }

    getResidentsNotificationSettings() {
        this.updatedApprovedCheckbox = false;
        this.updatedDeclinedCheckbox = false;

        if (this.selectedItemData == null) return;

        const url = `/v1/corporation_number/${this.selectedItemData.id}.json?expand=reminders,settings,buildings,staffNotificationSettings,staffNotificationSettings.userRoles,residentsNotificationSettings=[${this.selectedItemData.residentsNotificationSettings}]`;
        this.api.get('domainBD', url).subscribe(
            (res) => {
                const body = JSON.parse(res._body);
                if (body.residentsNotificationSettings.length) {
                    this.updatedApprovedCheckbox = body.residentsNotificationSettings[0].enableStatus ? true : false;
                    this.updatedDeclinedCheckbox = body.residentsNotificationSettings[1].enableStatus ? true : false;
                    this.selectedItemData.residentsNotificationSettings = body.residentsNotificationSettings;
                }
            },
            (error) => {
                this.showServiceUnavailable = true;
                this.spinnerShow = false;
                this.api.errorHandler(error, 'Failed get Residents Notification Settings');
            },
            () => {
                this.spinnerShow = false;
                this.showCorporationsList = true;
            }
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/settings-directory.service.ts